// A map glyph polygon as inline SVG, so the legend shows the same shapes as the map.
export function Glyph({
  points,
  color,
  filled = true,
  className = 'size-3',
}: {
  points: readonly number[];
  color: string;
  filled?: boolean;
  className?: string;
}) {
  return (
    <svg viewBox="-1.3 -1.3 2.6 2.6" className={className} aria-hidden>
      <polygon
        points={points.join(' ')}
        fill={filled ? color : 'none'}
        stroke={filled ? 'none' : color}
        strokeWidth={0.25}
      />
    </svg>
  );
}
